@if (initialPageLoad) {
  <ngx-spinner type="ball-grid-pulse" size="medium" [fullScreen]="true">
    <h3>Loading...</h3>
  </ngx-spinner>
}


<div class="page-wrap" [lxResponsiveClass]="pageResponsiveClass"  >
  <ui-new-shell [theme]="theme" [style]="style">
    <ui-new-top-bar [logoUrl]="logoUrl" (refreshClicked)="onRefresh()" (logoRendered)="onTopBarLogoRendered()"></ui-new-top-bar>
    <ui-new-tabs-bar
      [upgradeAvailability]="upgradeAvailability"
      [selectedTab]="selectedTab"
      [endDate]="endDate"
      [viewMode]="viewMode"
      [showCart]="!requestOnlyMode && shoppingCartService.getNumberOfOffersInShoppingCart(offerAliasId) > 0"
      [offerCount]="fullOffers.length"
      (selectedTabChange)="onTabChanged($event)"
      (viewModeChange)="viewMode = $event"
      (filterToggle)="toggleFilters()"
    ></ui-new-tabs-bar>

    @if(selectedTab === 'ROOM' && !loadingPage) {
      <div class="featured-summary" id="featuredSummary">
        <div class="featured-summary-title" data-theme-key="--text-main">
          @if(!filtersOpen){<span class="material-icons" aria-hidden="true">auto_awesome</span><span style="font-size: 13px;">{{getFeaturedOfferCount()}} Featured Upgrades</span>}
          <button class="featured-summary-link" id="viewAllUpgrades" type="button" (click)="toggleFilters()">@if(!filtersOpen){View all {{offers.length}} {{selectedTab | titlecase}} Upgrades}@else {View {{getFeaturedOfferCount()}} Featured Upgrades Only}<span class="material-icons" aria-hidden="true">arrow_forward</span>
          </button>
        </div>
      </div>
    }

    <div class="offers-wrapper" data-theme-key="--bg-card-alt">
      <!-- Inline loader for post-initial offer switching -->
      <!-- Inline loader for post-initial offer switching -->
      @if (!initialPageLoad && loadingPage) {
        <div class="inline-loading-panel" aria-live="polite">
          <div class="inline-loading-indicator">
            <div class="inline-loading-spinner" aria-hidden="true">
              <span class="spinner-arc spinner-arc-outer"></span>
              <span class="spinner-arc spinner-arc-inner"></span>
            </div>
            <div class="inline-loading-text">Loading...</div>
          </div>
        </div>
      }

      <!-- Prevent stale offer UI from flashing during tab switches / loads -->
      @if(!loadingPage) {
        <ng-container>
          <ui-new-filter-panel
            [isOpen]="filtersOpen"
            [tags]="tags"
            [bedTypes]="bedTypes"
            [tagsDict]="tagsDict"
            [bedTypesDict]="bedTypesDict"
            [hasFeaturedOffers]="hasFeaturedOffers"
            [featuredOnly]="featuredOnly"
            [hasFavoriteOffers]="hasFavoriteOffers"
            [favoriteOnly]="favoriteOnly"
            (searchChanged)="onSearchChanged($event)"
            (tagClicked)="onTagClicked($event)"
            (bedTypeClicked)="onBedTypeClicked($event)"
            (featuredClicked)="onFeaturedClicked()"
            (favoriteClicked)="onFavoriteClicked()"
          ></ui-new-filter-panel>

          <div class="offers" [class.tiles]="viewMode === 'tiles'" [class.list]="viewMode === 'list'">
            <ng-container
              *ngComponentOutlet="
                uiNewOfferListComponent;
                inputs: {
                  requestOnlyMode: requestOnlyMode,
                  activeOfferType: selectedTab,
                  viewMode: viewMode,
                  offers: (filteredOffers$ | async)
                }
              "
            ></ng-container>
          </div>

          <ui-new-view-bar
            [hasOffers]="!!sharedService.offers"
            [selectedTab]="selectedTab"
            [viewMoreToggle]="viewMoreToggle"
            [viewMoreOrLessText]="viewMoreOrLess((filteredOffers$ | async) ?? null)"
            [offers]="(filteredOffers$ | async)"
            [offerCount]="fullOffers.length"
            (noThanksClicked)="declineOffer()"
            (viewMoreClicked)="toggleSearch()"
          ></ui-new-view-bar>
        </ng-container>
      }
    </div>

  @if(initialPageLoad && loadingPage) {
        <div class="bottom-bar"></div>
    }

  </ui-new-shell>

  <footer class="main-footer">
    Upgrade offers are provided by Prestay.luxe on behalf of {{ sharedService.propertyName | titlecase }}.
    Review our
    <a href="" (click)="$event.preventDefault(); navigatePrivacy()">Privacy Policy</a>
    and
    <a href="" (click)="$event.preventDefault(); navigateTerms()">Terms of Service</a>.
  </footer>
</div>


